<div class="search">
    <form [formGroup]="searchForm" (ngSubmit)="filterItems()">
        <div class="form-controls">
            <input
                hamInput
                icon="/assets/hamIcons/search-outline.svg"
                formControlName="searchTerm"
                [placeholder]="placeholder"
                (keydown.enter)="onSearchEnter()"
                (cancel)="resetFilter()"
                [shouldHighliteBlueWhenValueEntered]="true"
            />
            <ham-button
                *ngIf="hasFilterButton"
                icon="assets/hamIcons/search-outline.svg"
                (buttonClick)="filterItems()"
                type="submit"
            >
                {{ searchButtonLabel }}
            </ham-button>
        </div>
    </form>
</div>
